import { generateIconComponent } from './icons.utils';

export const ChevronDownLightIcon = generateIconComponent({
    name: 'ChevronDownLightIcon',
    viewBox: '0 0 24 24',
    path: (
        <path d="M-8.88837e-07 6.26575C-8.7468e-07 5.94188 0.123982 5.61801 0.369416 5.37005C0.865343 4.87665 1.6649 4.87665 2.16083 5.37005L12.0009 15.2127L21.8411 5.37005C22.3345 4.87665 23.1366 4.87665 23.63 5.37005C24.1233 5.86598 24.1233 6.66553 23.63 7.16146L12.8941 17.8973C12.6563 18.1326 12.3349 18.2667 12.0009 18.2667C11.6644 18.2667 11.3431 18.1326 11.1052 17.8973L0.369415 7.16146C0.123982 6.9135 -9.02993e-07 6.58962 -8.88837e-07 6.26575Z" />
    ),
});
